import { CKContainerProps } from 'clearkit';

import { PageLayout } from '../unified/PageLayout';

export const PageWrapper = ({ children, ...rest }: CKContainerProps) => (
  <PageLayout {...rest} className="@container/list">
    {children}
  </PageLayout>
);
